const WPM = 200;
const IPS = WPM / 30;
const ATTRIBUTES = ['subtitle', 'text', 'title'];
const IMAGE = 'image';
const IMAGES = 'images';

export default ({ text = '', pages = [] } = {}) => {
  let words = text.split(' ').length;

  if (pages.length > 0) {
    pages.forEach((page) => {
      Object.keys(page).forEach((key) => {
        if (ATTRIBUTES.includes(key)) words += page[key].split(' ').length;

        if (key === IMAGE) words += IPS;
        if (key === IMAGES) words += (page[key].length * IPS);
      });
    });
  }

  return {
    seconds: Math.round(words / (WPM / 60)),
    minutes: Math.round(words / WPM),
  };
};
